// File: src/layouts/MobileAppLayout.tsx
import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { LayoutProvider } from '../contexts/LayoutContext';
import CommonHeader from './CommonHeader';
import { 
    HomeIcon, ChatBubbleLeftRightIcon, CalendarDaysIcon, 
    SparklesIcon, CurrencyDollarIcon // NEW: Import CurrencyDollarIcon
} from '@heroicons/react/24/outline';
import { useAuth } from '../hooks/useAuth';
import { UserRoleEnum } from '../types';

const MobileAppLayout: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  const homePath = user?.role_name === UserRoleEnum.Coach ? '/app/coach-dashboard' : '/app';

  const bottomNavItems = [
    { path: homePath, icon: <HomeIcon className="h-6 w-6" />, label: 'Home' },
    { path: '/app/client/appointments-hub', icon: <CalendarDaysIcon className="h-6 w-6" />, label: 'Appointments', roles: [UserRoleEnum.Client] },
    // MODIFIED: The coach's appointment link now points to the availability page
    { path: '/app/coach/availability', icon: <CalendarDaysIcon className="h-6 w-6" />, label: 'Appointments', roles: [UserRoleEnum.Coach] },
    { path: '/app/messages', icon: <ChatBubbleLeftRightIcon className="h-6 w-6" />, label: 'Messages', roles: [UserRoleEnum.Client, UserRoleEnum.Coach] },
    // NEW: Invoicing link for both roles
    { path: user?.role_name === UserRoleEnum.Coach ? '/app/coach/invoices' : '/app/client/invoices', icon: <CurrencyDollarIcon className="h-6 w-6" />, label: 'Invoices', roles: [UserRoleEnum.Client, UserRoleEnum.Coach] },
    { path: '/app/ai', icon: <SparklesIcon className="h-6 w-6 text-red-500" />, label: 'AI Assistant' },
  ];
  
  const visibleNavItems = bottomNavItems.filter(item => !item.roles || (user && item.roles.includes(user.role_name)));

  return (
    <div className="min-h-screen flex flex-col bg-neutral-light">
      <LayoutProvider>
        <CommonHeader />
        <main className="flex-1 overflow-y-auto p-4 pb-20 flex flex-col">
          <Outlet />
        </main>
        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-neutral-light shadow-top z-40 flex justify-around items-center h-16">
          {visibleNavItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center py-1 px-2 w-1/4
                          text-[11px] leading-tight  
                          ${
                            location.pathname.startsWith(item.path) && (item.path !== '/' || location.pathname === '/')
                              ? 'text-primary' : 'text-neutral-dark hover:text-primary-dark'}`}
            >
              {item.icon}
              <span className="mt-0.5">{item.label}</span>
            </Link>
          ))}
        </nav>
      </LayoutProvider>
    </div>
  );
};

export default MobileAppLayout;